<template>
  <v-container class="mx-5 mt-n2 table-container">
  <item-list :items="entries" :itemsPerPage="itemsPerPage" :headers="headers" :bottomText="$t('changed.perPage')" 
    @search="searchInput" @sortBy="getSortedBy" :searchLabel="$t('searchHistory')" :title="$t('organisms')" :showStatusFilter="false">
    <template slot="tfooter">
      <table-footer :key="footerKey" :page="page" ref="tfooter"  :search="search" :tableInfo="this.$extractions.getOrganismsPagingInfo"  @callback="setRequestInterval"/>
    </template>
  </item-list>
  <v-layout>
      <v-row>
        <v-col cols="12" justify="end" align-self="end">
          <v-btn color="#5f98ed" dark rounded class="mr-4 mb-5 float-sm-right" @click="createOrganism">{{$t('createOrganism')}}</v-btn>
        </v-col>
      </v-row>
    </v-layout>
</v-container>
</template>

<script>
export default {
  components:{
    ItemList: ()=> import('@/components/base/ItemList'),
    TableFooter: ()=>import('@/components/base/TableFooter'),
  },
  data () {
    return {
      entries: [],
      itemsPerPage:10,
      sortBy: undefined,
      sortDesc: undefined,
      footerKey: 0,
      //userListInterval: 0,
    }
  },
  computed:{
    headers: {
      get(){
        return [
        {
          text: this.$t('organismName'),
          align: 'start',
          value: 'name'
        },
        {
          text: this.$t('description'),
          align: 'start',
          value: 'description',
          sortable: false
        },
        {
          text: this.$t('phone'),
          align: 'start',
          value: 'telephone',
          sortable: false
        },
        {
          text: this.$t('actions'),
          align: 'start',
          value: 'actions',
          sortable: false
        }      
      ]
    }
  },
  search: {
    get(){
      return this.$store.getters.getSearch
    },
    set(value){
      return this.$store.commit('setSearch', value)
    }
  },
  interval: {
    get(){
      return this.$store.getters.getSearchInterval
    },
    set(value){
      return this.$store.commit('setSearchInterval', value)
    }
  },
  page: {
    get(){
      return this.$store.getters.getPage
    },
    set(value){
        return this.$store.commit('setPage', value)
    }
  }
  },
  async mounted(){
    await this.setRequestInterval(this.page, this.itemsPerPage)
  },
  beforeDestroy(){
    clearInterval(this.interval)
    this.interval = 0
  },
  methods: {
    getSortedBy(sortBy, desc){
      this.sortBy = sortBy
      this.sortDesc = desc
      this.setRequestInterval(this.page, this.itemsPerPage)
    },
    async setRequestInterval(page=1, itemsPerPage=10){
      this.page=page
      this.itemsPerPage = itemsPerPage
      if(this.interval!==0)
        clearInterval(this.interval)
      await this.getData()
      this.interval = setInterval(this.getData,5000)
    },
     async getData(){
      this.$extractions.getOrganisms(this.page,this.itemsPerPage,this.sortBy, this.sortDesc,this.search).then(response=>{
        if(response.data.length===0){
          if((this.search!=="")&&(this.page===1)){
            this.entries = []    
          }
          if(this.page>1){
            this.page --
            this.$refs.tfooter.stepBack(this.page)
          }else{
            this.$refs.tfooter.stepBack(1)
          }
        } else {
          this.entries = response.data   
        }        
      }).catch(()=>{
        return null
      })   
    },
    searchInput(searched){
      this.page =1
      this.search=searched
      //this.$extractions.cancelCall()
      this.footerKey++
      this.setRequestInterval()
    },
    createOrganism(){
      this.$router.push("/organism/create")
    },
  }
  
}
</script>
<style>
  .table-container{
    max-width: 98%!important;
  }
  @media (max-width: 1263px) {
    .table-container{
      max-width: 99%!important;
    }
  }
  @media (max-width: 450px){
    .v-application .mx-5{
      margin-left: 0px!important;
    }
    .v-data-table__mobile-row__cell{
      width: 170px!important;
      font-size: 13px!important;
    }
    .v-data-table__mobile-row__header{
      font-size: 13px!important;
    }
  }
  @media (max-width: 400px) {
    .v-data-table__mobile-row__cell{
      width: 150px!important;
      font-size: 12px;
    }
    .v-data-table__mobile-row__header{
      width: 150px!important;
    }
  }
  @media (max-width: 350px) {
    .v-data-table__mobile-row__cell{
      width: 110px!important;
    }
    .v-data-table__mobile-row__header{
      width: 110px!important;
    }
  }
</style>